var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from '@angular/core';
var FooterLoggedOutComponent = (function () {
    function FooterLoggedOutComponent() {
    }
    FooterLoggedOutComponent = __decorate([
        Component({
            selector: 'cx-footer-loggedout',
            templateUrl: './common/footer_loggedout.component.html',
        })
    ], FooterLoggedOutComponent);
    return FooterLoggedOutComponent;
}());
export { FooterLoggedOutComponent };
//# sourceMappingURL=footer-loggedout.component.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer-loggedout.component.js
// module id = 1165
// module chunks = 0